const pageConfig = {
  state: {
    pageName: ""
  },

  mutations: {
    SET_PAGENAME: (state, pageName) => {
      state.pageName = pageName;
    }
  },

  actions: {}
};

export default pageConfig;



// WEBPACK FOOTER //
// ./src/store/modules/pageConfig.js